module.exports = "<div class=\"modal-header bg-light dk\"><div class=\"modal-title\"><div class=\"text-info-dker h4\">Re-Login Required</div></div></div><div class=\"modal-body clear bg-white-only\"><div class=\"pull-left\"><div class=\"wrapper-xs h4 text-black\">You are no longer logged in. Please Re-authenticate.</div></div><div class=\"pull-right\"><a class=\"btn btn-success btn-md\" ng-href=\"{{$ctrl.LOGIN}}\">Log In</a></div></div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/auth/reauth/reauth.pug
// module id = 170
// module chunks = 0